module.exports = __webpack_public_path__ + "static/illustration-c7fdad25b5c205a862b269d25f832c1f.png";